import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { documentTypes, DOCUMENT_TAGS } from "@/js/lists.ts";
import { ERROR_DATA, getErrorData, handleErrorData } from "@/js/forms.js";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
import ManageDocumentsTagsDialog from "@/components/document-tags/ManageDocumentsTagsDialog.vue";
import AddTagToDocumentDialog from "@/components/document-tags/AddTagToDocumentDialog.vue";
import OrderRelatedFilesTable from "@/components/order/AdminSummarySubs/AttachedFiles/OrderRelatedFilesTable.vue";
import UploaderV2 from "@/components/default/UploaderV2.vue";
export default {
  name: "OrderAttachedFilesDrawer",
  components: {
    UploaderV2: UploaderV2,
    confirm: confirmationComponent,
    ErrorModal: ErrorModal,
    AddTagToDocumentDialog: AddTagToDocumentDialog,
    ManageDocumentsTagsDialog: ManageDocumentsTagsDialog,
    OrderRelatedFilesTable: OrderRelatedFilesTable
  },
  props: {
    order: Object,
    loggedUserData: Object
  },
  data: function data() {
    return {
      drawer: false,
      isMakingDrawerStateless: false,
      orderDocuments: [],
      wineDocuments: [],
      wineryDocuments: [],
      loadings: {
        isLoadingOrderFiles: false,
        isLoadingWineFiles: false,
        isLoadingWineryFiles: false
      },
      documentTypes: documentTypes,
      filters: {
        search: null,
        selectedTags: []
      },
      gettingDocumentTags: {
        isPending: false,
        cancellationToken: null,
        results: []
      },
      uploadAdditionalData: {
        tagId: null
      },
      DOCUMENT_TAGS: DOCUMENT_TAGS,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    uploadUrl: function uploadUrl() {
      return "".concat(process.env.VUE_APP_API_URL, "/v1/uploader/order/").concat(this.order.id_order, "/files");
    },
    uploadAdditionalFormData: function uploadAdditionalFormData() {
      return _objectSpread({}, this.uploadAdditionalData);
    },
    isOrderImporterInternal: function isOrderImporterInternal() {
      var _this$order$importer;
      return (_this$order$importer = this.order.importer) === null || _this$order$importer === void 0 ? void 0 : _this$order$importer.isInternalImporter;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this2.fetchOrderDocuments();
          case 2:
            _this2.fetchDocumentTags();
            _this2.fetchWineDocuments();
            _this2.fetchWineryDocuments();
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    openDrawer: function openDrawer() {
      this.drawer = true;
      this.fetchDocumentTags();
      this.fetchWineDocuments();
      this.fetchWineryDocuments();
    },
    closeDrawer: function closeDrawer() {
      this.drawer = false;
    },
    openFileUrl: function openFileUrl(url) {
      window.open(url, "_blank");
    },
    updateFilters: function updateFilters(filters) {
      this.filters = filters;
    },
    fetchDocumentTags: function fetchDocumentTags() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3$gettingDocumen;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.gettingDocumentTags.isPending = true;
              (_this3$gettingDocumen = _this3.gettingDocumentTags.cancellationToken) === null || _this3$gettingDocumen === void 0 || _this3$gettingDocumen.cancel();
              _this3.gettingDocumentTags.cancellationToken = axios.CancelToken.source();
              _this = _this3;
              _context2.next = 6;
              return request("/v1/document-tags/all", "get", null, true, "api", null, _this.gettingDocumentTags.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, "Unable to get list of tags", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 6:
              response = _context2.sent;
              _this3.gettingDocumentTags.results = _toConsumableArray(response.data.items);
              _this3.gettingDocumentTags.isPending = false;
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchOrderDocuments: function fetchOrderDocuments() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this = _this4;
              _this4.loadings.isLoadingOrderFiles = true;
              _context3.next = 4;
              return request("/v1/order/".concat(_this4.order.id_order, "/files"), "get", null, true, "api", null, _this4.filesCancelToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to load files.", {
                    type: "error"
                  });
                  _this.loadings.isLoadingOrderFiles = false;
                  throw e;
                }
              });
            case 4:
              response = _context3.sent;
              if (response) _this4.orderDocuments = _toConsumableArray(response.data);
              _this4.loadings.isLoadingOrderFiles = false;
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    fetchWineDocuments: function fetchWineDocuments() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this = _this5;
              _this5.loadings.isLoadingWineFiles = true;
              _context4.next = 4;
              return request("/v1/order/".concat(_this5.order.id_order, "/files/wines"), "post", {
                items: _this5.order.items,
                searchLabel: _this5.filters.search,
                documentTags: _this5.filters.selectedTags
              }, true, "api", null, _this5.filesCancelToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to load files.", {
                    type: "error"
                  });
                  _this.loadings.loadings.isLoadingWineFiles = false;
                  throw e;
                }
              });
            case 4:
              response = _context4.sent;
              if (response) _this5.wineDocuments = _toConsumableArray(response.data);
              _this5.loadings.isLoadingWineFiles = false;
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    fetchWineryDocuments: function fetchWineryDocuments() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this = _this6;
              _this6.loadings.isLoadingWineryFiles = true;
              _context5.next = 4;
              return request("/v1/order/".concat(_this6.order.id_order, "/files/wineries"), "post", {
                items: _this6.order.items,
                searchLabel: _this6.filters.search,
                documentTags: _this6.filters.selectedTags
              }, true, "api", null, _this6.filesCancelToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to load files.", {
                    type: "error"
                  });
                  _this.loadings.loadings.isLoadingWineryFiles = false;
                  throw e;
                }
              });
            case 4:
              response = _context5.sent;
              if (response) _this6.wineryDocuments = _toConsumableArray(response.data);
              _this6.loadings.isLoadingWineryFiles = false;
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    upload: function upload() {
      this.fetchOrderDocuments();
      this.uploadAdditionalData.tagId = null;
    },
    removeFile: function removeFile(id) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var confirmed, _this;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this7.isMakingDrawerStateless = true;
              _context6.next = 3;
              return _this7.$refs.confirm.open("Cancel", "Are you sure you want to remove this file?", {
                color: "red"
              });
            case 3:
              confirmed = _context6.sent;
              if (!confirmed) {
                _context6.next = 10;
                break;
              }
              _this7.loadings.isLoadingOrderFiles = true;
              _this = _this7;
              _context6.next = 9;
              return request("/v1/order/".concat(_this7.order.id_order, "/files/").concat(id), "delete", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to remove this purchase order.", {
                  type: "error"
                });
                _this.loadings.loadings.isLoadingOrderFiles = false;
                throw e;
              });
            case 9:
              _this7.fetchOrderDocuments();
            case 10:
              _this7.isMakingDrawerStateless = false;
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    openTagsDialog: function openTagsDialog() {
      this.$refs.ManageDocumentsTagsDialog.openDialog();
    },
    openAddTagToDocument: function openAddTagToDocument(idDocument) {
      this.$refs.AddTagToDocumentDialog.openDialog(idDocument, this.documentTypes.ORDER);
    },
    canRemoveTagFromDocument: function canRemoveTagFromDocument(file) {
      return file.tag.id !== DOCUMENT_TAGS.ORDER_FINAL_INVOICE.tagId || !this.isOrderImporterInternal;
    },
    canDeleteDocument: function canDeleteDocument(file) {
      var _file$tag;
      return ((_file$tag = file.tag) === null || _file$tag === void 0 ? void 0 : _file$tag.id) !== DOCUMENT_TAGS.ORDER_FINAL_INVOICE.tagId || !this.isOrderImporterInternal;
    },
    removeTagFromDocument: function removeTagFromDocument(idDocument) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this = _this8;
              _this.$refs.confirm.open("Delete", "Are you sure you want to delete this tag ?", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(confirm) {
                  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        if (!confirm) {
                          _context7.next = 3;
                          break;
                        }
                        _context7.next = 3;
                        return request("/v1/document-tags/type/".concat(_this.documentTypes.ORDER.id), "delete", {
                          idDocument: idDocument
                        }, true, "api").then(function (response) {
                          _this.tagListChangedUpdate();
                        }).catch(function (error) {
                          _this.$toasted.show("Unable to remove tag from document.", {
                            type: "error"
                          });
                          throw error;
                        });
                      case 3:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    tagListChangedUpdate: function tagListChangedUpdate() {
      this.fetchOrderDocuments();
      this.fetchDocumentTags();
      this.$refs.AddTagToDocumentDialog.fetchDocumentTags();
      this.$refs.ManageDocumentsTagsDialog.fetchDocumentTags();
    }
  }
};